export const ewaKotecka = {
    'meta': {
        'title': 'Psychoterapeuta integratywny, terapeuta EMDR Ewa Kotecka',
        'description': 'Jestem psychologiem, psychodietetykiem i psychoterapeutką w trakcie szkolenia w nurcie Analizy Transakcyjnej.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psycholog-psychoterapeuta-ewa-kotecka/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/ewa-kotecka.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Bydgoszczy, Psychoterapeuta w Bydgoszczy Ewa Kotecka'
        }
    }
}